import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import Footer from "@/components/Footer";
import * as Sentry from "@sentry/react";
import { ToastContainer } from "react-toastify";

const posthog_options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};
const posthog_client = posthog.init(
  import.meta.env.VITE_PUBLIC_POSTHOG_API_KEY,
  posthog_options
);

Sentry.init({
  dsn: "https://0054720df1edd86263ecc84776805e9a@sentry.twinhelix.co.uk/5",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/www\.aptfleet\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthog_client}>
      <App />
      <Footer />
      <ToastContainer />
    </PostHogProvider>
  </StrictMode>
);
